// noinspection TypeScriptUnresolvedReference,DuplicatedCode

// The format the selection of entities is stored in the hidden input
interface EntitySelection {
    teams: number[];
    users: number[];
    functionalEntities: number[];
}

// The format of the entities used in the UI
interface UiEntity {
    id: number;
    label: string;
    type: string;
    selected: boolean;
    teamUsers?: number[];
}

enum EntityType {
    Team = 'team',
    User = 'user',
    FunctionalEntity = 'functionalEntity',
}

// noinspection JSUnusedGlobalSymbols
export default function () {
    $(function () {
        // Get DOM elements
        const teamEntitiesSelect = document.getElementById('team-entities-select') as HTMLSelectElement;
        const userEntitiesSelect = document.getElementById('user-entities-select') as HTMLSelectElement;
        const functionalEntitiesSelect = document.getElementById('functional-entities-select') as HTMLSelectElement;
        const hiddenInput = $('#item-id-3010');

        // Get trigger elements
        const teamTrigger = document.getElementById('team-entities-trigger') as HTMLElement;
        const userTrigger = document.getElementById('user-entities-trigger') as HTMLElement;
        const functionalEntitiesTrigger = document.getElementById('functional-entities-trigger') as HTMLElement;

        // Get dropdown containers
        const teamDropdownContainer = document.getElementById('team-dropdown-container') as HTMLElement;
        const userDropdownContainer = document.getElementById('user-dropdown-container') as HTMLElement;
        const functionalEntitiesDropdownContainer = document.getElementById('functional-dropdown-container') as HTMLElement;


        // Get search inputs
        const teamSearchInput = teamDropdownContainer.querySelector('.search-input') as HTMLInputElement;
        const userSearchInput = userDropdownContainer.querySelector('.search-input') as HTMLInputElement;
        const functionalEntitySearchInput = functionalEntitiesDropdownContainer.querySelector('.search-input') as HTMLInputElement;

        // Get close dropdown buttons
        const teamCloseDropdown = document.getElementById('team-close-dropdown') as HTMLElement;
        const userCloseDropdown = document.getElementById('user-close-dropdown') as HTMLElement;
        const functionalEntitiesCloseDropdown = document.getElementById('functional-entities-close-dropdown') as HTMLElement;

        // Get options containers
        const teamOptionsContainer = document.getElementById('team-entities-options') as HTMLElement;
        const userOptionsContainer = document.getElementById('user-entities-options') as HTMLElement;
        const functionalEntitiesOptionsContainer = document.getElementById('functional-entities-options') as HTMLElement;

        // Get selected items containers
        const teamSelectedItemsContainer = teamDropdownContainer.querySelector('.selected-items-container') as HTMLElement;
        const userSelectedItemsContainer = userDropdownContainer.querySelector('.selected-items-container') as HTMLElement;
        const functionalEntitiesSelectedItemsContainer = functionalEntitiesDropdownContainer.querySelector('.selected-items-container') as HTMLElement;

        // Store entities data
        const teamEntities: UiEntity[] = [];
        const userEntities: UiEntity[] = [];
        const functionalEntities: UiEntity[] = [];

        // Store current search text
        let teamSearchText = '';
        let userSearchText = '';
        let functionalEntitiesSearchText = '';

        // Function to clear search input and reset filter
        function clearSearchInput(container: HTMLElement) {
            const searchInput = container.querySelector('.search-input') as HTMLInputElement;
            if (searchInput) {
                searchInput.value = '';

                // Reset the corresponding search text variable
                if (container === teamDropdownContainer) {
                    teamSearchText = '';
                    filterOptions(teamEntities, teamOptionsContainer, '');
                } else if (container === userDropdownContainer) {
                    userSearchText = '';
                    filterOptions(userEntities, userOptionsContainer, '');
                } else if (container === functionalEntitiesDropdownContainer) {
                    functionalEntitiesSearchText = '';
                    filterOptions(functionalEntities, functionalEntitiesOptionsContainer, '');
                }
            }
        }

        // Parse entities from select elements
        parseEntities();

        // Initialize the UI
        filterOptions(teamEntities, teamOptionsContainer, teamSearchText);
        filterOptions(userEntities, userOptionsContainer, userSearchText);
        filterOptions(functionalEntities, functionalEntitiesOptionsContainer, functionalEntitiesSearchText);

        // Load initial values if any
        loadInitialValues();

        // Add event listeners
        setupEventListeners();

        // Parse entities from select elements
        function parseEntities() {
            // Parse team entities
            Array.from(teamEntitiesSelect.options).forEach(option => {
                // Get team users if available
                let teamUsers: number[] = [];
                const teamUsersStr = option.getAttribute('data-team-users');
                if (teamUsersStr) {
                    try {
                        teamUsers = JSON.parse(teamUsersStr);
                    } catch (e) {
                        console.error('Error parsing team users:', e);
                    }
                }

                teamEntities.push({
                    id: parseInt(option.value),
                    label: option.text,
                    type: option.getAttribute('data-type') || '',
                    selected: false,
                    teamUsers: teamUsers
                });
            });

            // Parse user entities
            Array.from(userEntitiesSelect.options).forEach(option => {
                userEntities.push({
                    id: parseInt(option.value),
                    label: option.text,
                    type: option.getAttribute('data-type') || '',
                    selected: false
                });
            });

            // Parse functional entities
            Array.from(functionalEntitiesSelect.options).forEach(option => {
                functionalEntities.push({
                    id: parseInt(option.value),
                    label: option.text,
                    type: option.getAttribute('data-type') || '',
                    selected: false
                });
            });
        }

        // Setup event listeners
        function setupEventListeners() {
            // Toggle dropdown when clicking on trigger
            teamTrigger.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleDropdown(teamDropdownContainer);
            });
            userTrigger.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleDropdown(userDropdownContainer);
            });
            functionalEntitiesTrigger.addEventListener('click', (e) => {
                e.stopPropagation();
                toggleDropdown(functionalEntitiesDropdownContainer);
            });

            // Handle search input
            teamSearchInput.addEventListener('input', () => {
                teamSearchText = teamSearchInput.value;
                filterOptions(teamEntities, teamOptionsContainer, teamSearchText);
            });
            userSearchInput.addEventListener('input', () => {
                userSearchText = userSearchInput.value; // was: userFunctionalSearchInput.value
                filterOptions(userEntities, userOptionsContainer, userSearchText);
            });
            functionalEntitySearchInput.addEventListener('input', () => {
                functionalEntitiesSearchText = functionalEntitySearchInput.value;
                filterOptions(functionalEntities, functionalEntitiesOptionsContainer, functionalEntitiesSearchText);
            });

            // Close dropdown when clicking outside
            document.addEventListener('click', (e) => {
                const target = e.target as HTMLElement;

                // Check if click is outside from dropdown
                if (!teamDropdownContainer.contains(target)) {
                    teamDropdownContainer.classList.remove('active');
                    clearSearchInput(teamDropdownContainer);
                }
                if (!userDropdownContainer.contains(target)) {
                    userDropdownContainer.classList.remove('active');
                    clearSearchInput(userDropdownContainer);
                }
                if (!functionalEntitiesDropdownContainer.contains(target)) {
                    functionalEntitiesDropdownContainer.classList.remove('active');
                    clearSearchInput(functionalEntitiesDropdownContainer);
                }
            });

            // Prevent dropdown from closing when clicking inside
            teamDropdownContainer.querySelector('.custom-dropdown')?.addEventListener('click', (e) => {
                e.stopPropagation();
            });
            userDropdownContainer.querySelector('.custom-dropdown')?.addEventListener('click', (e) => {
                e.stopPropagation();
            });
            functionalEntitiesDropdownContainer.querySelector('.custom-dropdown')?.addEventListener('click', (e) => {
                e.stopPropagation();
            });

            // Close dropdown when clicking or touching on close button
            const closeTeamDropdown = (e: Event) => {
                e.stopPropagation();
                teamDropdownContainer.classList.remove('active');
                clearSearchInput(teamDropdownContainer);
            };
            const closeUserDropdown = (e: Event) => {
                e.stopPropagation();
                userDropdownContainer.classList.remove('active');
                clearSearchInput(userDropdownContainer);
            };
            const closeFunctionalEntitiesDropdown = (e: Event) => {
                e.stopPropagation();
                functionalEntitiesDropdownContainer.classList.remove('active');
                clearSearchInput(functionalEntitiesDropdownContainer);
            };

            // Add click event listeners
            teamCloseDropdown?.addEventListener('click', closeTeamDropdown);
            userCloseDropdown?.addEventListener('click', closeUserDropdown);
            functionalEntitiesCloseDropdown?.addEventListener('click', closeFunctionalEntitiesDropdown);

            // Add touch event listeners for mobile devices
            teamCloseDropdown?.addEventListener('touchend', closeTeamDropdown);
            userCloseDropdown?.addEventListener('touchend', closeUserDropdown);
            functionalEntitiesCloseDropdown?.addEventListener('touchend', closeFunctionalEntitiesDropdown);
        }

        // Toggle dropdown visibility
        function toggleDropdown(container: HTMLElement) {
            // Close all dropdowns first
            document.querySelectorAll('.custom-dropdown-container').forEach(el => {
                if (el !== container) {
                    el.classList.remove('active');
                    clearSearchInput(el as HTMLElement);
                }
            });

            // Toggle active class
            container.classList.toggle('active');

            // Focus search input if dropdown is open
            if (container.classList.contains('active')) {
                const searchInput = container.querySelector('.search-input') as HTMLInputElement;
                if (searchInput) {
                    setTimeout(() => searchInput.focus(), 10);
                }
            }
        }

        // Render options in the dropdown
        function renderOptions(entities: UiEntity[], container: HTMLElement) {
            // Clear container
            container.innerHTML = '';

            const entityType = container === teamOptionsContainer ?
                EntityType.Team :
                container === userOptionsContainer ?
                    EntityType.User :
                    EntityType.FunctionalEntity;

            // Determine which select element to use based on the container
            const selectElement = container === teamOptionsContainer
                ? teamEntitiesSelect
                : container === userOptionsContainer
                    ? userEntitiesSelect
                    : functionalEntitiesSelect;

            // Get the optgroup labels dynamically from the select element
            const optgroups = Array.from(selectElement.querySelectorAll('optgroup'));
            const closeOptgroup = optgroups.find(og => og.className === 'school');
            const otherOptgroup = optgroups.find(og => og.className === 'other');

            const closeLabel = closeOptgroup?.label || 'Meine Schuleinheit';
            const otherLabel = otherOptgroup?.label || 'Andere';

            // Group entities by optgroup
            const closeEntities = entities.filter(entity => {
                const option = Array.from(selectElement.options).find(opt => parseInt(opt.value) === entity.id);
                const optgroup = option?.parentElement;
                return optgroup instanceof HTMLOptGroupElement && optgroup.label === closeLabel;
            });

            const otherEntities = entities.filter(entity => {
                const option = Array.from(selectElement.options).find(opt => parseInt(opt.value) === entity.id);
                const optgroup = option?.parentElement;
                return optgroup instanceof HTMLOptGroupElement && optgroup.label === otherLabel;
            });

            // Render close relations group
            if (closeEntities.length > 0) {
                const closeGroup = document.createElement('div');
                closeGroup.className = 'option-group';

                const closeHeader = document.createElement('div');
                closeHeader.className = 'option-group-header';
                closeHeader.textContent = closeLabel;
                closeGroup.appendChild(closeHeader);

                closeEntities.forEach(entity => {
                    const optionItem = createOptionItem(entity, entityType);
                    closeGroup.appendChild(optionItem);
                });

                container.appendChild(closeGroup);
            }

            // Render other relations group
            if (otherEntities.length > 0) {
                const otherGroup = document.createElement('div');
                otherGroup.className = 'option-group';

                const otherHeader = document.createElement('div');
                otherHeader.className = 'option-group-header';
                otherHeader.textContent = otherLabel;
                otherGroup.appendChild(otherHeader);

                otherEntities.forEach(entity => {
                    const optionItem = createOptionItem(entity, entityType);
                    otherGroup.appendChild(optionItem);
                });

                container.appendChild(otherGroup);
            }
        }

        // Create an option item element
        function createOptionItem(entity: UiEntity, entityType: EntityType): HTMLElement {
            const optionItem = document.createElement('div');
            optionItem.className = 'option-item';
            if (entity.selected) {
                optionItem.classList.add('selected');
            }
            optionItem.textContent = entity.label;
            optionItem.dataset.id = entity.id.toString();
            optionItem.dataset.type = entity.type;

            // Add click event to toggle selection
            optionItem.addEventListener('click', () => {
                toggleSelection(entity, entityType);
            });

            return optionItem;
        }

        // Filter options based on search input
        function filterOptions(entities: UiEntity[], container: HTMLElement, searchText: string) {
            const filteredEntities = searchText.trim() === ''
                ? entities
                : entities.filter(entity =>
                    entity.label.toLowerCase().includes(searchText.toLowerCase())
                );

            renderOptions(filteredEntities, container);
        }

        // Toggle selection of an entity
        function toggleSelection(entity: UiEntity, entityType: EntityType) {
            entity.selected = !entity.selected;

            // If this is a team, automatically select/deselect its users
            if (entityType === EntityType.Team && entity.type === 'team' && entity.teamUsers && entity.teamUsers.length > 0) {
                if (entity.selected) {
                    // If team is being selected, select all its users
                    userEntities.forEach(userEntity => {
                        if (userEntity.type === 'user' && entity.teamUsers && entity.teamUsers.includes(userEntity.id)) {
                            userEntity.selected = true;
                        }
                    });
                } else {
                    // If team is being deselected, only deselect users that are not part of any other selected team
                    // Get all selected teams
                    const selectedTeams = teamEntities.filter(team => team.selected && team.type === 'team' && team.id !== entity.id);

                    // Deselect each user in the team if they are not part of any other selected team
                    userEntities.forEach(userEntity => {
                        if (userEntity.type === 'user' && entity.teamUsers && entity.teamUsers.includes(userEntity.id)) {
                            // Check if this user is part of any other selected team
                            const isInOtherSelectedTeam = selectedTeams.some(team =>
                                team.teamUsers && team.teamUsers.includes(userEntity.id)
                            );

                            // Only deselect if not part of any other selected team
                            if (!isInOtherSelectedTeam) {
                                userEntity.selected = false;
                            }
                        }
                    });
                }

                // Update user UI
                filterOptions(userEntities, userOptionsContainer, userSearchText);
                renderSelectedItems(userEntities, userSelectedItemsContainer, EntityType.User);
            }

            // Update UI
            if (entityType === EntityType.Team) {
                filterOptions(teamEntities, teamOptionsContainer, teamSearchText);
                renderSelectedItems(teamEntities, teamSelectedItemsContainer, entityType);
                renderSelectedItems(userEntities, userSelectedItemsContainer, EntityType.User);
            } else if (entityType === EntityType.User) {
                filterOptions(userEntities, userOptionsContainer, userSearchText);
                renderSelectedItems(userEntities, userSelectedItemsContainer, entityType);
            } else if (entityType === EntityType.FunctionalEntity) {
                filterOptions(functionalEntities, functionalEntitiesOptionsContainer, functionalEntitiesSearchText);
                renderSelectedItems(functionalEntities, functionalEntitiesSelectedItemsContainer, entityType);
            }

            // Update hidden input
            updateHiddenInput();
        }

        // Render selected items in the trigger
        function renderSelectedItems(entities: UiEntity[], container: HTMLElement, entityType: EntityType) {
            // Clear container
            container.innerHTML = '';

            // Get selected entities
            const selectedEntities = entities.filter(entity => entity.selected);

            // Update placeholder visibility
            const placeholder = container.closest('.custom-dropdown-container')?.querySelector('.placeholder') as HTMLElement;
            if (placeholder) {
                // Ensure placeholder is visible when no items are selected
                if (selectedEntities.length === 0) {
                    placeholder.style.display = 'block';
                } else {
                    placeholder.style.display = 'none';
                }
            }

            // Ensure the trigger has the correct cursor style
            const trigger = container.closest('.custom-dropdown-trigger') as HTMLElement;
            if (trigger) {
                trigger.style.cursor = 'pointer';
            }

            // Render selected items
            selectedEntities.forEach(entity => {
                const selectedItem = document.createElement('div');
                selectedItem.className = 'selected-item';
                selectedItem.textContent = entity.label;

                const removeButton = document.createElement('span');
                removeButton.className = 'remove-item';
                removeButton.innerHTML = '&times;';
                removeButton.addEventListener('click', (e) => {
                    e.stopPropagation(); // Prevent dropdown from toggling
                    entity.selected = false;

                    // If this is a team, automatically deselect its users only if they are not part of any other selected team
                    if (entityType === EntityType.Team && entity.type === 'team' && entity.teamUsers && entity.teamUsers.length > 0) {
                        // Get all selected teams
                        const selectedTeams = teamEntities.filter(team => team.selected && team.type === 'team' && team.id !== entity.id);

                        // Deselect each user in the team if they are not part of any other selected team
                        userEntities.forEach(userEntity => {
                            if (userEntity.type === 'user' && entity.teamUsers && entity.teamUsers.includes(userEntity.id)) {
                                // Check if this user is part of any other selected team
                                const isInOtherSelectedTeam = selectedTeams.some(team =>
                                    team.teamUsers && team.teamUsers.includes(userEntity.id)
                                );

                                // Only deselect if not part of any other selected team
                                if (!isInOtherSelectedTeam) {
                                    userEntity.selected = false;
                                }
                            }
                        });

                        // Update user entities UI
                        filterOptions(userEntities, userOptionsContainer, userSearchText);
                        renderSelectedItems(userEntities, userSelectedItemsContainer, entityType);
                    }

                    // Update UI
                    if (entityType === EntityType.Team) {
                        filterOptions(teamEntities, teamOptionsContainer, teamSearchText);
                        renderSelectedItems(teamEntities, teamSelectedItemsContainer, entityType);
                        renderSelectedItems(userEntities, userSelectedItemsContainer, EntityType.User);
                    } else if (entityType === EntityType.User) {
                        filterOptions(userEntities, userOptionsContainer, userSearchText);
                        renderSelectedItems(userEntities, userSelectedItemsContainer, entityType);
                    } else if (entityType === EntityType.FunctionalEntity) {
                        filterOptions(functionalEntities, functionalEntitiesOptionsContainer, functionalEntitiesSearchText);
                        renderSelectedItems(functionalEntities, functionalEntitiesSelectedItemsContainer, entityType);
                    }

                    // Update hidden input
                    updateHiddenInput();
                });
                selectedItem.appendChild(removeButton);

                container.appendChild(selectedItem);
            });
        }

        // Load initial values from hidden input
        function loadInitialValues() {
            try {
                const value = hiddenInput.val() as string;
                if (value) {
                    const selection: EntitySelection = JSON.parse(value);

                    // Set selected values for team entities
                    if (selection.teams && selection.teams.length > 0) {
                        selection.teams.forEach(id => {
                            const entity = teamEntities.find(e => e.id === id);
                            if (entity) {
                                entity.selected = true;
                            }
                        });
                    }

                    // Set selected values for user and functional entities
                    if (selection.users && selection.users.length > 0) {
                        selection.users.forEach(id => {
                            const entity = userEntities.find(e => e.id === id && e.type === 'user');
                            if (entity) {
                                entity.selected = true;
                            }
                        });
                    }

                    if (selection.functionalEntities && selection.functionalEntities.length > 0) {
                        selection.functionalEntities.forEach(id => {
                            const entity = functionalEntities.find(e => e.id === id && e.type === 'functionalEntity');
                            if (entity) {
                                entity.selected = true;
                            }
                        });
                    }

                    // Update UI
                    filterOptions(teamEntities, teamOptionsContainer, teamSearchText);
                    filterOptions(userEntities, userOptionsContainer, userSearchText);
                    filterOptions(functionalEntities, functionalEntitiesOptionsContainer, functionalEntitiesSearchText);
                    renderSelectedItems(teamEntities, teamSelectedItemsContainer, EntityType.Team);
                    renderSelectedItems(userEntities, userSelectedItemsContainer, EntityType.User);
                    renderSelectedItems(functionalEntities, functionalEntitiesSelectedItemsContainer, EntityType.FunctionalEntity);
                }
            } catch (e) {
                console.error('Error parsing initial values:', e);
            }
        }

        // Update hidden input with selected values
        function updateHiddenInput() {
            const selection: EntitySelection = {
                teams: [],
                users: [],
                functionalEntities: []
            };

            // Process team entities
            teamEntities.forEach(entity => {
                if (entity.selected && entity.type === 'team') {
                    selection.teams.push(entity.id);
                }
            });

            // Process user entities
            userEntities.forEach(entity => {
                if (entity.selected && entity.type === 'user') {
                    selection.users.push(entity.id);
                }
            });

            // Process functional entities
            functionalEntities.forEach(entity => {
                if (entity.selected && entity.type === 'functionalEntity') {
                    selection.functionalEntities.push(entity.id);
                }
            });

            // Update hidden input
            if (selection.teams.length === 0 && selection.users.length === 0 && selection.functionalEntities.length === 0) {
                hiddenInput.val('');
            } else {
                hiddenInput.val(JSON.stringify(selection));
            }
        }
    });
}
